import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import styled from 'styled-components';
import { Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import { ErrorContent } from '@sierralabs/core-ui';
const StyledTableContainer = styled(TableContainer) `
  table {
    border-collapse: collapse;
    width: 100%;
  }
  thead th {
    background-color: #dddddd;
  }
  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 5px;
    font-size: 15px;
  }
`;
const CSVViewer = ({ fileUrl, className }) => {
    var _a, _b;
    const [rows, setRows] = useState([]);
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        Papa.parse(fileUrl, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: data => {
                setRows(data);
                setIsLoading(false);
            },
            error: csvParseError => {
                setError(csvParseError);
                setIsLoading(false);
            }
        });
    }, [fileUrl]);
    return (React.createElement(StyledTableContainer, { className: className },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null, (_a = rows.meta) === null || _a === void 0 ? void 0 : _a.fields.map((colummName, columnIndex) => (React.createElement(TableCell, { key: columnIndex }, colummName))))),
            React.createElement(TableBody, null, rows.data &&
                ((_b = rows.data) === null || _b === void 0 ? void 0 : _b.map((row, rowIndex) => {
                    var _a, _b;
                    return (React.createElement(TableRow, { key: rowIndex }, (_b = (_a = rows.meta) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.map((columnName, columnIndex) => (React.createElement(TableCell, { key: `col-${rowIndex}-${columnIndex}` }, row[columnName])))));
                })))),
        isLoading && !error && (React.createElement(Box, { display: 'flex', padding: '20px', alignItems: 'center', flexDirection: 'column' },
            React.createElement(CircularProgress, { color: 'primary' }),
            React.createElement(Box, { mt: 2 },
                React.createElement(Typography, { variant: 'body1', className: 'text' }, "Loading CSV...")))),
        !isLoading && error && (React.createElement(ErrorContent, { title: 'CSV Error', className: 'text', icon: React.createElement(Warning, { className: 'icon', color: 'disabled' }), description: React.createElement(Typography, { variant: 'body1', className: 'text-secondary' }, error.message || 'Failed to load CSV file.') }))));
};
export default CSVViewer;
//# sourceMappingURL=CSVViewer.js.map